// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,

  apiurl: 'https://selfcaredemo.realmeds.io/api',
  externalUrl:'https://selfcaredemo.realmeds.io',
  //******************************
  //websocket configuration
  //******************************
  websocketApiKey: "ecb97147-cb91-47d5-9b0f-d63bbcb78985",
  socketUrl:'https://apidemo.realmeds.io',
  aggregatorsocketUrl: 'https://selfcaredemo.realmeds.io',

  profilePicsContainer: 'demo.realmeds-profilepics',
  productPicsContainer: 'demo.realmeds-productpics',
  labelsContainer: 'demo.labels',
  epcisfilesContainer: 'demo.realmeds-epcisfiles',

  geoCodeAPI: 'AIzaSyCP3iX9mpRBwJ3MPdkgV2IZDejmJebtHuc',
  geoCodeUrl: 'https://maps.googleapis.com/maps/api/geocode/json?latlng=',

  firebase: {
    apiKey: "AIzaSyAZ5QenbtP_qK6E4lZpcmbjBXzQs1FFadQ",
    authDomain: "realmedstest.firebaseapp.com",
    projectId: "realmedstest",
    storageBucket: "realmedstest.appspot.com",
    messagingSenderId: "59717483341",
    appId: "1:59717483341:web:9a5ba462070f49959b9504",
    measurementId: "G-JK153EYCK8"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
